/*! Copyright (c) Safe As Milk. All rights reserved. */
import DeferredMedia from "deferred-media";

class LazyVideo extends DeferredMedia {
    connectedCallback() {
        const lazyVideoObserver = new IntersectionObserver((entries => {
            entries.forEach((entry => {
                const lazyVideo = entry.target;
                if (entry.isIntersecting) {
                    if (!lazyVideo.hasAttribute("loaded")) {
                        lazyVideo.loadContent();
                        const videoElement = lazyVideo.querySelector("video");
                        // POP'S BIRDING (Oct 2026): keep the poster image showing until the
                        // video is actually playing. Before, the poster was hidden as soon as
                        // the video element was added ([loaded=true] sets its opacity to 0), so
                        // a video that couldn't play (iPhone Low Power Mode, data saver,
                        // unsupported format) left an empty gray box. "pending" keeps the
                        // poster visible; "failed" removes the video and keeps the poster.
                        lazyVideo.setAttribute("loaded", "pending");
                        videoElement.addEventListener("playing", (() => {
                            if (videoElement.isConnected) lazyVideo.setAttribute("loaded", "true");
                        }), { once: true });
                        const showPoster = () => {
                            videoElement.remove();
                            lazyVideo.setAttribute("loaded", "failed");
                        };
                        videoElement.addEventListener("error", showPoster, { once: true, capture: true });
                        videoElement.play().catch((error => {
                            if (error.name !== "AbortError") showPoster();
                        }));
                    } else {
                        const videoElement = lazyVideo.querySelector("video");
                        if (videoElement) videoElement.play();
                    }
                } else {
                    if (!lazyVideo.hasAttribute("loaded")) return;
                    const videoElement = lazyVideo.querySelector("video");
                    if (videoElement) videoElement.pause();
                }
            }));
        }));
        lazyVideoObserver.observe(this);
    }
}

customElements.define("lazy-video", LazyVideo);
//# sourceMappingURL=lazy-video.js.map
